<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center bottom-0 left-0 right-0 top-0 !flex">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="flex-align-center !flex justify-between px-4 py-6">
                <p class="align-center flex-1 text-base font-bold">
                    {{ title | translate: { hours } }}
                </p>
            </div>
            <div class="content overflow-y-auto">
                <ng-container>
                    <div class="mx-4 text-center text-base font-normal">
                        {{ 'TICKET_WARNING_VALID_HOURS_DESCRIPTION' | translate }}
                    </div>
                </ng-container>
            </div>

            <div class="m-4">
                <button
                    class="sr-app-light:bg-secondary vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black h-14 w-full rounded-lg bg-primary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    (click)="close()">
                    {{ 'CLOSE' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
